import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import Button from 'react-bootstrap/lib/Button';
import classnames from 'classnames';

import FeatureFlagStore from '../../stores/FeatureFlagStore';
import UserStore from '../../stores/UserStore';
import User from '../../records/User';
import SmartcardStore from '../../stores/SmartcardStore';
import Smartcard from '../../records/customer/Smartcard';
import CustomerActions from '../../actions/CustomerActions';
import SmartcardCTAStore from '../../stores/SmartcardCTAStore';
import ModalActions from '../../actions/ModalActions';
import { GlobalModals } from '../../constants/AppConstants';

import { translate as t } from '../../lib/I18n';
import connectToStores from '../../helpers/connectToStores';

import PureRenderComponent from '../PureRenderComponent';
import SmartcardModal from '../account/SmartcardModal';
import FormattedHTMLMessage from '../general/FormattedHTMLMessage';
import KeyGoRegistrationModal from '../account/smartcard/KeyGoRegistrationModal';


const _handleDismiss = () => {
    CustomerActions.dismissSmartcardCTA();
};

const _handleRegisterUser = () => {
    ModalActions.open(GlobalModals.REGISTER, { forceSmartcardSignup: true });
};

@connectToStores([FeatureFlagStore, UserStore, SmartcardStore, SmartcardCTAStore], () => ({
    smartcard: SmartcardStore.getCurrent(),
    user: UserStore.getCurrent(),
    enableSmartcardCTA: FeatureFlagStore.get('enableSmartcardCTA'),
    enableKeyGoCTA: FeatureFlagStore.get('enableKeyGoCTA'),
    enableSmartcard: FeatureFlagStore.get('enableSmartcard'),
    dismissed: SmartcardCTAStore.get('dismissed'),
    showSmartcardModal: false,
}))
class SmartcardCTA extends PureRenderComponent {
    static propTypes = {
        smartcard: PropTypes.instanceOf(Smartcard),
        enableSmartcardCTA: PropTypes.bool.isRequired,
        enableKeyGoCTA: PropTypes.bool.isRequired,
        user: PropTypes.instanceOf(User),
        dismissed: PropTypes.bool.isRequired,
        className: PropTypes.string
    };

    static defaultProps = {
        className: ''
    };

    state = {
        showModal: false
    };

    UNSAFE_componentWillMount () {
        if (!this.props.enableSmartcardCTA) {
            return;
        }

        if (SmartcardStore.shouldGetSmartcard()) {
            CustomerActions.getSmartcard(this.props.user);
        }
    }

    _handleCancelled = () => {
        this.setState({ showModal: false });
    };

    _handleRegisterSmartcard = () => {
        this.setState({ showModal: true });
    };

    _canRegisterKeyGo() {
        const { smartcard, enableKeyGoCTA } = this.props;
        return smartcard && enableKeyGoCTA && smartcard.canSearchForProducts() && smartcard.canRegisterKeyGo();
    }

    get _keyGoMessage() {
        return (
            <FormattedHTMLMessage
                message='smartcardCTA.message.keyGo'
                br={ <br /> }
                keygobrand=
                    { <FormattedHTMLMessage message='account.smartcard.text.keygo'/> }
            />
        );
    }

    render () {
        const {
            className,
            enableSmartcardCTA,
            dismissed,
            smartcard,
            user,
            enableSmartcard
        } = this.props;
        const canRegisterKeyGo = this._canRegisterKeyGo();

        if (!enableSmartcardCTA || dismissed || !enableSmartcard || (smartcard && !canRegisterKeyGo)) {
            return null;
        }

        const registrationHandler = _.result(user, 'isLoggedIn') ? this._handleRegisterSmartcard : _handleRegisterUser;
        const Modal = canRegisterKeyGo ? KeyGoRegistrationModal : SmartcardModal;

        return (
            <div className={ classnames('smartcard-cta', className) } role="dialog"
                aria-modal="false"
                aria-describedby="cta__description">

                { this.state.showModal &&
                    <Modal
                        user={ user }
                        smartcard={ smartcard }
                        hideSmartcardCheckbox
                        onCancel={ this._handleCancelled } />
                }

                <p id="cta__description">
                    { canRegisterKeyGo ? this._keyGoMessage : t('smartcardCTA.message.smartcard') }
                </p>

                <Button bsStyle="default"
                    className="text-sm btn btn-dismiss"
                    onClick={ _handleDismiss }>
                    { t('global.banner.dismiss') }
                </Button>

                <Button bsStyle="primary"
                    className="text-sm btn btn-register"
                    onClick={ registrationHandler }>
                    { t(canRegisterKeyGo ? 'smartcardCTA.button.submit.keyGo' : 'smartcardCTA.button.submit.smartcard') }
                </Button>
            </div>
        );
    }
}

export default SmartcardCTA;



// WEBPACK FOOTER //
// ./src/components/smartcard/SmartcardCTA.js